<template>
  <div>
    <el-drawer @reload="$reloadHandle" title="中心审核" size="30%" :before-close="handleClose" :visible.sync="drawer"
      append-to-body="ture" direction="rtl" :modal-append-to-body="true" custom-class="demo-drawer" ref="drawer">
      <i class="el-icon-info" />
      单据号：<span v-if="exchangeNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
        exchangeNo }}</span>
      <div class="demo-drawer__content">
        <div id="containt">
          <div class="tab-box">
            <el-form :label-position="right" label-width="80px" ref="editForm" :model="formData">
              <div class="d-item">
                <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">
                  <div class="title first"><b>附件列表</b></div>
                  <el-upload style="display:flex; float: right" class="upload-demo" ref="upload"
                    :action="api.uploadFileUrl"  :show-file-list="false"
                    :on-success="(res, file, fileList) => { handleFileSuccess(res, file, fileList) }" :headers="headers"
                    :on-progress="upVideo"

                    :auto-upload="true">
                    <el-button type="primary" class="button-sty btn_zdy">
                      <i class="el-icon-plus"></i>
                      附件
                    </el-button>
                  </el-upload>
                </div>
                <div>
                  <vxe-table style="margin-top: 0px;" :stripe="true"
                    :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                    show-overflow height="210" :column-config="{ resizable: true }" @checkbox-change="selectChangeEvent"
                    @checkbox-all="selectChangeEvent" :data="orgFileList">
                    <vxe-column type="checkbox" width="40" />
                    <vxe-column field="fileName" title="附件名称" width="400">
                      <template #default="{ row }">
                        <!-- <a :href="row.fileUrl" :download="row.name">{{ row.fileName }}</a> -->
                        <span @click="openVideo(row.fileUrl)">{{ row.fileName }}</span>

                      </template>
                    </vxe-column>
                    <vxe-column title="操作" width="90">
                      <template #default="{ row }">
                        <div>
                          <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                            popper-class="tooltip-skin">
                            <i @click="deleteFile(row)" class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                          </el-tooltip>

                          <el-tooltip :enterable="false" effect="dark" content="下载" placement="top"
                            popper-class="tooltip-skin">
                            <i @click="handleDownload(row.fileName, row.fileUrl)" class="el-icon-download"
                              style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                          </el-tooltip>

                          <el-tooltip :enterable="false" effect="dark" content="预览文件" placement="top"
                            popper-class="tooltip-skin">
                            <i @click="openVideo(row.fileUrl)" class="el-icon-view"
                              style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                          </el-tooltip>
                        </div>
                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>
              </div>
              <el-form-item label="备注" >
                <el-input type="textarea" autocomplete="off" v-model="formData.messageContent" :disabled="able"
                  style="width:10vw!important;" clearable />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>

      <div class="demo-drawer__content">
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary"  :diabled="siteAppealButton" @click="siteAppeal">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import store from "@/store";
import api from "@/api/projectApi";
import { dictType, loadDictData } from "@/config/dictType";

export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi', 'confirmNo', 'dataId', 'wf'],
  computed: {
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }

  },
  created() {
    console.log(this.wf)
    this.formData.id = this.dataId
    if (this.wf) {
      this.exchangeNo = this.wf.orderNo
      this.formData.processId = this.wf.processId
      this.formData.taskId = this.wf.taskId
      this.formData.messageContent = this.wf.messageContent
      this.formData.id = this.wf.orderId
      if (this.wf.wfView) {
				this.wfView = this.wf.wfView
				if (this.wfView.indexOf('?') != -1) {
					var queryString = this.wfView.split('?')[1];
					let params = new URLSearchParams(queryString);
					this.type = params.has('type') ? params.get('type') : 0;
				}
			}
    }
  },
  data() {
    return {

      type: null,
      // uploadFileUrl: api.uploadFileUrl,
      orgFileList: [],

      identifyResultList: [],
      identifyResultFilterList: [],
      qualityIdentifyList: [],
      responsibilityIdentifyList: [],
      exchangeNo: '',

      siteAppealButton: false,

      formData: {
        id: null,
        processId: null,
        taskId: null,

        // qualityIdentify: null,
        // qualityIdentifyName: null,
        // identifyResult: null,
        // identifyResultName: null,
        // responsibilityIdentify: null,
        // responsibilityIdentifyName: null,
        // canFix:null,

        orgFileList: [],
        messageContent:null,
      },
      showOrderPop: false,

      drawer: true,
    }
  },
  methods: {
    getIdentifyResult() {
      let qualityIdentifyName = '';
      let qualityIdentify = this.formData.qualityIdentify;
      if (qualityIdentify) {
        this.qualityIdentifyList.forEach(item => {
          if (qualityIdentify === item.value) {
            qualityIdentifyName = item.label
          }
        })
      }

      this.formData.identifyResult = null
      this.formData.identifyResultName = ""

      console.log("getIdentifyResult")
      this.identifyResultFilterList = []
      this.identifyResultList.forEach(item => {
        console.log("item.lable" + item.label)
        console.log(item)
        if (item.label.startsWith(qualityIdentifyName)) {
          this.identifyResultFilterList.push({
            label: item.label,
            value: item.value
          })
        }
      })
    },
    handleFileSuccess(res, file, fileList) {
      let url = res.data.url
      let fileName = file.name
      console.log(url, "url")
      console.log(fileName, "name")
      this.orgFileList.push({
        fileName: fileName,
        fileUrl: url,
        type: this.type,
      })
      this.$message({
          message: '附件上传成功',
          type: 'success'
        });
        this.$mask.close()
    },
    deleteFile(row) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        console.log(row, 'delete')
        this.orgFileList = this.orgFileList.filter(item => item.url !== row.url)
      })
    },
    // 文件下载
    handleDownload(Vname, Vurl) {
      console.log(Vname, Vurl, "文件下载");
      // let url=file.type
      let url = Vurl
      let name = Vname

      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()


      // window.open(url,'_blank');
    },
    // 文件预览
    openVideo(value) {
      this.imgVisbleURL = value
      this.showPreview = true
    },
    // 考核的确认
    siteAppeal() {
      this.formData.orgFileList = this.orgFileList
      this.$baseConfirm('您确定要保存吗？').then(() => {
        this.$mask.open()
        this.$http({
          url: api.wkAccidentReport.getDataUrl + "/orgCheck",
          method: 'post',
          data: this.formData
        }).then(res => {
          this.$mask.close()
          this.$message.success('确认成功')
          this.$emit('closeD')
          this.$emit('flushed')
        }).catch(() => {
          this.$mask.close()
        })
      })
    },
    // 加载数据字典中物流公司，运输方式
    loadDictData() {
      loadDictData("鉴定结果").then(res => {
        this.identifyResultList = []
        res.data.data.forEach(item => {
          this.identifyResultList.push({
            label: item.label,
            value: item.id
          })
        })
      })
      loadDictData("质量鉴定").then(res => {
        this.qualityIdentifyList = []
        res.data.data.forEach(item => {
          this.qualityIdentifyList.push({
            label: item.label,
            value: item.id
          })
        })
      })
      loadDictData("责任鉴定").then(res => {
        this.responsibilityIdentifyList = []
        res.data.data.forEach(item => {
          this.responsibilityIdentifyList.push({
            label: item.label,
            value: item.id
          })
        })
      })
    },
    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.loading = false;
      this.drawer = false;
      clearTimeout(this.timer);
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeD', false)
    }
  },
  mounted() {
    this.loadDictData()
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}
</style>
